import { render, staticRenderFns } from "./PriceStaffLinks.vue?vue&type=template&id=37749744&"
import script from "./PriceStaffLinks.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PriceStaffLinks.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37749744')) {
      api.createRecord('37749744', component.options)
    } else {
      api.reload('37749744', component.options)
    }
    module.hot.accept("./PriceStaffLinks.vue?vue&type=template&id=37749744&", function () {
      api.rerender('37749744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/price/_components/PriceSection/components/PriceStaffLinks.vue"
export default component.exports